
const Q = require('q');


module.exports = class PromiseQueue {
	constructor () {
		this._queue = [];
		this._running = null;
	}

	push (taskFunction) {
		const dfr = Q.defer();

		this._queue.push(() => {
			const taskPromise = Q.Promise((resolve, reject) => {
				Q(taskFunction()).then(resolve, reject);
			});
			dfr.resolve(taskPromise);
			return taskPromise;
		});
		this._shift();

		return dfr.promise;
	}

	_shift () {
		if (this._running) {
			return;
		}

		const next = this._queue.shift();
		if (next) {
			this._running = Q().then(() => next()).finally(() => {
				this._running = null;
				this._shift();
			});
		}
	}

	wrap (fn) {
		const that = this;
		return function (...args) {
			return that.push(fn.bind(this, ...args));
		};
	}
};
